export { setInputTestId as setNumericInputTestId } from "@bcc/components/ui/input/input.utils";
